import { render, staticRenderFns } from "./avatarIcon.vue?vue&type=template&id=36a10148&scoped=true&lang=pug"
import script from "./avatarIcon.vue?vue&type=script&lang=js"
export * from "./avatarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a10148",
  null
  
)

export default component.exports